export default "__VITE_ASSET__BKk2r9V3__"